import r from "./index.es75.js";
import o from "./index.es76.js";
function l(e, s) {
  const t = Object.assign({}, r(e), { key: s });
  return typeof t.style == "string" || t.style instanceof String ? t.style = o(t.style) : delete t.style, t;
}
export {
  l as default
};
//# sourceMappingURL=index.es56.js.map
